import { cn } from '@bridebook/aura';

export const Divider = ({ className }: { className?: string }) => (
  <div
    className={cn(
      'mx-auto h-[1px] w-[100px] shrink-0 bg-[var(--ww-palette-divider)] @screen-lg:w-[var(--divider-width-lg)]',
      className,
    )}
  />
);
